module.exports = __webpack_public_path__ + "img/Truppführer_Betreuungstrupp.7bd38391.svg";